import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map, mergeMap, shareReplay, tap } from 'rxjs/operators';

import { plainToClass } from 'class-transformer';
import { environment } from 'src/environments/environment';
import { BaseConfig } from './models/config.model';

@Injectable()
export class ConfigService {
  private $config: Observable<BaseConfig> | null = null;

  constructor(private http: HttpClient) {}

  getConfig(): Observable<BaseConfig> {
    if (this.$config === null) {
      this.$config = this.http
        .get<object>(environment.configUrl)
        .pipe(
          map((obj) => {
            const config = plainToClass(BaseConfig, obj);
            config.validate();

            return config;
          }),
        )
        .pipe(
          tap({
            error: (error) => {
              console.log('Error retrieving config:', error);
            },
          }),
        )
        .pipe(shareReplay(1));
    }
    return this.$config;
  }
}

export class ServiceWithConfigBase {
  protected config: Observable<BaseConfig>;

  constructor(configService: ConfigService) {
    this.config = configService.getConfig();
  }

  wrapForConfig<R>(
    func: (config: BaseConfig) => Observable<R>,
  ): Observable<R> {
    return this.config.pipe(mergeMap((config) => func(config)));
  }
}
